const today = new Date();
export const endDate = today.toISOString().split("T")[0]

export const getDateBefore = (days) => {
  const d = new Date();
  d.setDate(today.getDate() - days);
  return d.toISOString().split("T")[0];
};
